/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".invalid[_ngcontent-%COMP%]{border:1px solid rgba(255,100,100,.9)}"];
export { styles as styles };
